const STANDARD_WHITE_1 = {
  url: 'https://res.insta360.com/static/fc14b2c484e7e7d7fbb1d2475aa5cbe2/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpg',
  urlL: 'https://res.insta360.com/static/6ea5115383d1bedba1d9ff50eb6f6ace/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@3x.jpg',
  url_m:
    'https://res.insta360.com/static/fc14b2c484e7e7d7fbb1d2475aa5cbe2/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpg',
  url_s:
    'https://res.insta360.com/static/7bb6d1cbeb090db67da9490c0482beaf/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD.jpg',
};
const STANDARD_BLACK_1 = {
  url: 'https://res.insta360.com/static/961d54f73b089e98a948a54c88dbd370/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/fcb6324a2e2c6427b370a7bd7ba46845/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@3x.jpg',
  url_m:
    'https://res.insta360.com/static/961d54f73b089e98a948a54c88dbd370/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpg',
  url_s:
    'https://res.insta360.com/static/945947520681375fb2c1fb6adf6f77f8/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91.jpg',
};
const STANDARD_2 = {
  url: 'https://res.insta360.com/static/73c7b3ccf9dd376a0bae72950a30daaa/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpg',
  urlL: 'https://res.insta360.com/static/5f9023bfe0e02a55a907c0ad18efe4d8/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@3x.jpg',
  url_m:
    'https://res.insta360.com/static/73c7b3ccf9dd376a0bae72950a30daaa/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpg',
  url_s: 'https://res.insta360.com/static/06e5fc79be90163a5bc097b86e5564e2/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002.jpg',
};
const STANDARD_3 = {
  url: 'https://res.insta360.com/static/9f303b359abea6f4fded93eaa4329f28/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpg',
  urlL: 'https://res.insta360.com/static/9bf8791684c215fe5a0196ec7eb96b43/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@3x.jpg',
  url_m:
    'https://res.insta360.com/static/9f303b359abea6f4fded93eaa4329f28/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpg',
  url_s: 'https://res.insta360.com/static/d1b4e0e9f3ddae6452c0a0cb2bd8aa68/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003.jpg',
};
const STANDARD_4 = {
  url: 'https://res.insta360.com/static/913d45417d38d8c16d325b6a8042c483/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpg',
  urlL: 'https://res.insta360.com/static/fcc1276117642575793fed637c79cfff/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@3x.jpg',
  url_m:
    'https://res.insta360.com/static/913d45417d38d8c16d325b6a8042c483/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpg',
  url_s: 'https://res.insta360.com/static/24816bb2d507262cebb73b9219a0d99f/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004.jpg',
};
const FAMILY_WHITE_1 = {
  url: 'https://res.insta360.com/static/b88cc6d5fbefd30b9ee783dcc8d7c964/02@2x.jpg',
  urlL: 'https://res.insta360.com/static/841a8210456286e13ff86d8c6bc6b173/02@3x.jpg',
  url_m: 'https://res.insta360.com/static/b88cc6d5fbefd30b9ee783dcc8d7c964/02@2x.jpg',
  url_s: 'https://res.insta360.com/static/9b693b5a365b4cdd52a2f1827d197718/02.jpg',
};
const FAMILY_BLACK_1 = {
  url: 'https://res.insta360.com/static/5b4b8cde0729c44848727b8e16d13208/03-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/258ad9ba842db03b4a83043d8a28ca9d/03-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/5b4b8cde0729c44848727b8e16d13208/03-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/2ca61c2b7374e37c3f21cf5d3b015e2d/03-%E9%BB%91.jpg',
};
const FAMILY_2 = {
  url: 'https://res.insta360.com/static/799e63cf1cb7780b5900cdb3fdc03de8/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/bbc4c711389386c51dde258f74a5833e/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/799e63cf1cb7780b5900cdb3fdc03de8/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/b538b5b2f976ab5fd4620eb9b1b0bb81/04.jpg',
};
const FAMILY_3 = {
  url: 'https://res.insta360.com/static/87eccbbc4c1249f0b264930ff5ba0dc9/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/4c32e276ee8430992aef00a54d854bd6/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/87eccbbc4c1249f0b264930ff5ba0dc9/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/5d568fe271fd6c25f90da00fd2db0f4f/05.jpg',
};
const FAMILY_4 = {
  url: 'https://res.insta360.com/static/fb2a80fb50af4ea9e8064340c97cf772/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/d463a050a2e13d6e5f32c0809d0730a9/01@3x.jpgj',
  url_m: 'https://res.insta360.com/static/fb2a80fb50af4ea9e8064340c97cf772/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/176f9a426d21bde3928dc55172fe38b9/01.jpg',
};
const ULTIMATE_WHITE_1 = {
  url: 'https://res.insta360.com/static/7daf9e2e6db2b2d33aa49fbe443b1e2b/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/32ae329ba92ccd69b9882b89e7760578/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/7daf9e2e6db2b2d33aa49fbe443b1e2b/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/bb8554229d2f6b23dfd65cf5ae2e4bc2/01.jpg',
};
const ULTIMATE_BLACK_1 = {
  url: 'https://res.insta360.com/static/6802eea43356a3f64b58870dc4eaefec/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/6c172a6739b24e97e90578222041a90a/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/6802eea43356a3f64b58870dc4eaefec/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/125771502e983974ad280914b7cc0475/02-%E9%BB%91.jpg',
};
const ULTIMATE_2 = {
  url: 'https://res.insta360.com/static/c54531c734cde48c12a3432fe8ad689b/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/bd0759f07a31d236940f6e791bc551fc/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/c54531c734cde48c12a3432fe8ad689b/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/be555585ee3d1664db1552d0677e9bc7/03.jpg',
};
const ULTIMATE_3 = {
  url: 'https://res.insta360.com/static/7fee9c5ce8c394d8994fa672da9e70f9/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/1ce98c8eb7052f9d468cf922f4061627/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/7fee9c5ce8c394d8994fa672da9e70f9/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/faf360e932424b5c0df40dd324be0a11/04.jpg',
};
const ULTIMATE_4 = {
  url: 'https://res.insta360.com/static/83f86ee32538ecfdeacf6cf598f022d0/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/1ce98c8eb7052f9d468cf922f4061627/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/83f86ee32538ecfdeacf6cf598f022d0/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/22e80552b4d5924837ea6ccf31039654/05.jpg',
};

const ACTION_WHITE_1 = {
  url: 'https://res.insta360.com/static/5300af4d51469ba5d9bc1cca6776851b/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/87165a91043cb2b59c6df43222e22f27/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/5300af4d51469ba5d9bc1cca6776851b/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/012309807220fe7eb2679c9aee125ba8/01.jpg',
};
const ACTION_BLACK_1 = {
  url: 'https://res.insta360.com/static/ecf47d70bd3a494336eb1d03ece75020/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/0342695336f71c396eacefda68a7bb84/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/ecf47d70bd3a494336eb1d03ece75020/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/87459ad613be11a6dc62b86a7555931a/02-%E9%BB%91.jpg',
};
const ACTION_2 = {
  url: 'https://res.insta360.com/static/611f877d8892fdc0dd7ddc56bc47c920/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/391a0d7772f247b9e0c0f66b48de36ab/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/611f877d8892fdc0dd7ddc56bc47c920/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/bcac38641284dae2ff46c5afff03c5c1/03.jpg',
};
const ACTION_3 = {
  url: 'https://res.insta360.com/static/9632647ae7f46c229345a380c2b217b5/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/e9b500f481e3637f8de631ade21430af/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/9632647ae7f46c229345a380c2b217b5/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/6e4b56a3205a392e0a905bdb64ce66b1/04.jpg',
};

const ACTION_4 = {
  url: 'https://res.insta360.com/static/9190da5cf365731c7d0cc891a64605fe/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/5b4240cc9ee5286cd73c4580c67fe19f/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/9190da5cf365731c7d0cc891a64605fe/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/91e775a4b79d5108736c5e5bfbd54a4d/05.jpg',
};
const CREATOR_WHITE_1 = {
  url: 'https://res.insta360.com/static/a5631165df8cff2fcbc194873b99760b/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/59efbdabab092f8573bc9ec4360b0a61/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/a5631165df8cff2fcbc194873b99760b/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/fda5197bb62a22c88789929803e7f771/01.jpg',
};
const CREATOR_BLACK_1 = {
  url: 'https://res.insta360.com/static/7611857f68114b2c4ce4bc6095a74408/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/f1c0d59394b3999750c994cd2bb5c973/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/7611857f68114b2c4ce4bc6095a74408/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/42f569f8cfb2a50998c180b7bfedf0cf/02-%E9%BB%91.jpg',
};
const CREATOR_2 = {
  url: 'https://res.insta360.com/static/9017f7efb9f1617374afbf23b2a918af/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/ba716d5ac49a1127a633a57427f7984f/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/9017f7efb9f1617374afbf23b2a918af/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/6efa5292aed32d22fdf15bfde9442ada/03.jpg',
};
const CREATOR_3 = {
  url: 'https://res.insta360.com/static/8488b6273f5138527920046fc8f4286d/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/858ccb2d424635e928c190cb3eb8f000/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/8488b6273f5138527920046fc8f4286d/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/3f4768f404c8675b50ab249474f993b8/04.jpg',
};
const CREATOR_4 = {
  url: 'https://res.insta360.com/static/f3129d7d1e64e2e76943f30378b3c016/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/859add08a882cb944ce9ac011442455d/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/f3129d7d1e64e2e76943f30378b3c016/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/d25dcbce275478ab039b2d0510008695/05.jpg',
};
const WATER_WHITE_1 = {
  url: 'https://res.insta360.com/static/2d7782b099cf52f0187b02d0514095bf/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/38f0bbef22297814baff24b971d6a1fb/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/2d7782b099cf52f0187b02d0514095bf/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/42aeb5909e2fe28edb1a36e5e5c0a3e5/01.jpg',
};
const WATER_BLACK_1 = {
  url: 'https://res.insta360.com/static/56c907cd4c3c6b2f69f28e426349aef8/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/94c611f82a0a13d3d9f3299680ee7511/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/56c907cd4c3c6b2f69f28e426349aef8/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/64437a063629f2fd401dfc40d2750cd3/02-%E9%BB%91.jpg',
};
const WATER_2 = {
  url: 'https://res.insta360.com/static/86654e76e00c9b1bdca6df91b27c3dd8/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/34da063077fa48eb63f3a727a6f8ce47/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/86654e76e00c9b1bdca6df91b27c3dd8/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/1052a09f8fa15f56f504ae1c234c5ba4/03.jpg',
};
const WATER_3 = {
  url: 'https://res.insta360.com/static/9227027e769a23bdce5eafaefc084606/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/398e2b8ede5486d43d1cab8e73699367/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/9227027e769a23bdce5eafaefc084606/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/877cb5382871948ed0b8d3ad1039a5bc/04.jpg',
};

const resourcesMapperDE = new Map([
  [3125, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3135, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3120, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3130, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3121, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3131, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3126, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3136, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3469, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3470, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3471, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3472, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3122, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3132, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3127, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3137, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3478, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3479, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3480, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3481, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3123, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3133, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3128, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
  [3138, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
]);

export default resourcesMapperDE;
